import "../../_css/CustomButtom.css"

function CustomButtonLight({ text, onClick, fontSize = "14px", disabled = false }) {
    return (
        <button style={{ fontSize }} className="custom-btn-light" onClick={onClick} disabled={disabled}>
            {text}
        </button>
    )
}

export default CustomButtonLight